
import React, { useState, useEffect, useRef } from 'react'
import { Spin, Alert, Button } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import styles from './index.module.scss'
import Cookies from 'js-cookie'
import Loading from '@/components/base/loading'

const Dashboard: React.FC = () => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const iframeRef = useRef<HTMLIFrameElement>(null)

    // 从环境变量获取business-web URL
    // const businessWebUrl = 'http://47.76.33.67:6005'
    const businessWebUrl = 'https://combine-next.jarvisbro.com'

    // 获取保存的 token
    const savedToken = localStorage.getItem('business_web_token')

    // 修改：构建带有 token 的 URL，确保token正确传递
    // const dashboardUrl = savedToken
    //     ? `${businessWebUrl}/ai/dashboard?token=${encodeURIComponent(savedToken)}&autoLogin=true`
    //     : `${businessWebUrl}/ai/dashboard`

    // 构建带有详细样式参数的URL
    const styleParams = new URLSearchParams({
        hideHeader: 'true', nextCompat: 'r16',
    })

    const dashboardUrl = `${businessWebUrl}/ai/dashboard?${styleParams.toString()}`

    const handleIframeLoad = () => {
        setLoading(false)
        setError(null)
    }

    const handleIframeError = () => {
        setLoading(false)
        setError('无法加载Dashboard页面，请检查business-web服务是否正常运行')
    }

    const handleRefresh = () => {
        setLoading(true)
        setError(null)
        if (iframeRef.current) {
            iframeRef.current.src = dashboardUrl
        }
    }

    // 修改：添加useEffect来确保token存在
    useEffect(() => {
        if (!savedToken) {
            setError('未找到有效的登录token，请先登录')
            setLoading(false)
        }
    }, [savedToken])

    // 添加2秒后自动关闭loading的逻辑
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false)
        }, 1300) // 1.3秒后自动关闭

        return () => clearTimeout(timer) // 清理定时器
    }, []) // 空依赖数组，只在组件挂载时执行一次

    return (
        <div className={styles.dashboardContainer}>
            {loading && (
                <div className={styles.loadingContainer}>
                    <Loading />
                </div>
            )}
            <iframe
                ref={iframeRef}
                src={dashboardUrl}
                className={styles.dashboardIframe}
                onError={handleIframeError}
                title="Dashboard"
                sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation allow-downloads"
            />
        </div>
    )
}

export default Dashboard 